export const selectUserActivityLoading = (state) =>
  state?.userActivityReport?.isLoading;
export const selectUserActivityData = (state) =>
  state?.userActivityReport?.data;

export const selectUserActivityTableData = (state) =>
  state?.userActivityReport?.table;
export const selectUserActivityChart = (state) =>
  state?.userActivityReport?.chart;

export const selectDrilldownData = (state) =>
  state?.userActivityReport?.drilldownData;
export const selectDrilldownDataIsLoading = (state) =>
  state?.userActivityReport?.drilldownIsLoading;
export const selectTotalCount = (state) =>
  state?.userActivityReport?.totalCount;
export const selectCurrentDrillPage = (state) =>
  state?.userActivityReport?.currentDrillPage;
export const selectSearchTerm = (state) =>
  state?.userActivityReport?.searchTerm;
export const selectInitialLoading = (state) =>
  state?.userActivityReport?.initialLoading;
